import styled from "styled-components";

let titleBarHeight = 80;

export const ElectricWheelDetailsScreenWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-position: center;
    background-size: cover;
`;

export const ElectricWheelDetailsScreenInnerWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 850px;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-color: rgba(0, 0, 0, 0.85);
    background-image: url("/static/images/big-screen/electric-wheel/details-screen-background.png");
    background-size: 100% 100%;
`;

export const ScreenTitleBar = styled.div`
    position: absolute;
    z-index: 110;
    left: 0%;
    top: 0%;
    width: 100%;
    height: ${titleBarHeight-12}px;
    padding: 12px 20px 0px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-around;
`;

export const DeviceDetailsContent = styled.div`
    display: grid;
    position: absolute;
    top: calc(${titleBarHeight}px);
    width: 100%;
    height: calc(100% - ${titleBarHeight}px);
    padding: 10px 30px 40px 30px;
    overflow-x: hidden;
    overflow-y: hidden;
    grid-template-columns: repeat(10, minmax(0, 1fr));
    grid-template-rows: minmax(0, 0.75fr) minmax(0, 1.5fr) minmax(0, 1.5fr);
    grid-gap: 20px;
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
`;

export const DeviceDetailsWrapper = styled.div`
    width: 100%;
    flex: 0 0 auto;
    box-sizing: border-box;
    background-image: url("/static/images/big-screen/electric-wheel/device-information-border.png");
    background-size: 100% 100%;
`;

export const DeviceTrackWrapper = styled.div`
    grid-column: 1 / span 2;
    grid-row: 1 / span 2;
    padding: 5px 2px 7px 2px;
    box-sizing: border-box;
    background-image: url("/static/images/big-screen/electric-wheel/map-border.png");
    background-size: 100% 75%;
    background-repeat: no-repeat;

`;

export const DeviceModel3DWrapper = styled.div`
    grid-column: 3 / span 6;
    grid-row: 1 / span 2;
    z-index: 100;
    overflow: hidden;
`;

export const DeviceHealthWrapper = styled.div`
    z-index: 100;
    box-sizing: border-box;
`;

export const DeviceRealtimeMetricsWrapper = styled.div`
    grid-column: 1 / 2;
    grid-row: 2 / 3;
    z-index: 100;
    box-sizing: border-box;
`;

export const DeviceMetricsWrapper = styled.div`
    grid-column: 2 / 4;
    grid-row: 2 / 3;
    z-index: 100;
    box-sizing: border-box;
`;
